import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Typography from '../../../../UniformComponents/Typography'

import '../../ppbuilder.scss'

const ChartSlot = observer(({ store, position }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)
    const data = store.getChartDataForQuestion(question?.questionId, position)

    const handleRemoveQuestion = () => {
        store.removeQuestionData(question.questionId)
        store.activeSlide.removeQuestion(position)
    }

    const renderQuestion = () => {
        if (question.chart === 'verbatim') {
            return (
                <div style={{ height: '100%', width: '100%', padding: 20 }}>
                    <Typography type="h4">{question.questionShortText}</Typography>

                    <div style={{ height: 'calc(100% - 20px)', width: '100%' }}>
                        {[0, 1].map((i) => (
                            <div style={{ width: '100%', height: '50%' }}>
                                {!question?.chosenCategories.get(i)
                                    ? (
                                        <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }} onClick={() => store.handleOpenVerbatimSettingsModal(i, true, 2, position)}>
                                            <div className="pp-add-slide">
                                                <i className="fas fa-plus" />
                                            </div>

                                            <Typography>Add category</Typography>
                                        </div>
                                    ) : (
                                        <div style={{ height: '100%', width: '100%', cursor: 'pointer' }} onClick={() => store.handleOpenVerbatimSettingsModal(i, true, 2, position)}>
                                            <Typography type="b">
                                                {question?.chosenCategories.get(i)?.category}
                                            </Typography>

                                            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                                                <div className="pp-chart-slot-option-comment">
                                                    <Typography>
                                                        {question?.chosenCategories.get(i)?.labels[0] || ''}
                                                    </Typography>
                                                </div>

                                                <div className="pp-chart-slot-option-comment">
                                                    <Typography>
                                                        {question?.chosenCategories.get(i)?.labels[1] || ''}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        ))}
                    </div>
                </div>
            )
        }

        return store.getChart(
            {
                ...data,
                title: '',
                surveyId: question.surveyId,
                containerSize: { height: 400, width: 450 },
                chartType: question?.chart,
                settings: question.settings,
            },
            data?.data,
            [...question.comparisonYears, question.year],
        )
    }

    const handleEdit = () => {
        store.handleEditChart(position)
    }

    return (
        <div className="pp-chart-slot-container">
            <div className="pp-slide-controls">
                {question?.chart !== 'verbatim' && (
                    <div className="pp-slide-edit" onClick={handleEdit}>
                        <i className="fas fa-pen-to-square" />
                    </div>
                )}

                <div className="pp-slide-delete" onClick={handleRemoveQuestion}>
                    <i className="fas fa-trash" />
                </div>
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                {question ? renderQuestion() : (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5, width: '100%', height: '100%' }} onClick={store.handleAddQuestion}>
                        <div className="pp-add-slide">
                            <i className="fas fa-plus" />
                        </div>

                        <Typography>{i18n.t('q_editor_title_add')}</Typography>
                    </div>
                )}
            </div>
        </div>
    )
})

export default ChartSlot
